export default "__VITE_ASSET__D3jYFO9i__"